import React from 'react';
import { Helmet } from 'react-helmet';
import { Alert, Col, Row } from 'react-bootstrap';

export default function RegistrationCheckEmail() {
  return (
    <>
      <Helmet>
        <title>Check Email{process.env.REACT_APP_PAGETITLE_TEXT}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Row>
        <Col></Col>
        <Col xs={12} sm={10} md={8}>
          <br />
          <h2 className="text-center">Hold on, you’re not done yet…​</h2>
          <h2 className="text-center">
            <b>Check your email</b> to complete your registration.​
          </h2>
          <br />
          <Alert variant="success">
            <p className="text-center textup">
              A link was sent to your email which is valid for ONE HOUR.​
            </p>
            <p className="text-center textup">
              If you have any questions, please contact the Auditor’s office at
              (614) 525-HOME (4663) during office hours or email{' '}
              <a href="mailto:AuditorStinziano@franklincountyohio.gov?subject=Property eAlerts">
                AuditorStinziano@franklincountyohio.gov
              </a>
              .
            </p>
          </Alert>
        </Col>
        <Col></Col>
      </Row>
    </>
  );
}
